import { categorySchema } from "@/schema/free-assessment/Category";
import { z } from "zod";

export const freeAssessmentSchema = z.object({
  id: z.number(),
  main_categories: z.array(categorySchema),
});

export type FreeAssessment = z.infer<typeof freeAssessmentSchema>;
